import {
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGIN_USER,
  REGISTER_START,
  SETTOKEN,
} from "./constants";

const INITIAL_STATE = {
  isLoading: false,
  user: null,
  token: "",
  error: null,
};

const AuthenticationReducer = (state = INITIAL_STATE, action) => {
  const { type, response, error } = action;
  switch (type) {
    case REGISTER_START:
      break;
    case SETTOKEN:
      return { ...state, response };
    case LOGIN_USER:
      return { ...state, isLoading: true, error: null };
    case LOGIN_SUCCESS: {
      // let {token,user}= state
      const token = response.data.access;
      const user = response.data.user;
      return { ...state, isLoading: false, user, token, error: null };
    }
    case LOGIN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: error.response?.data ?? { detail: error.message },
      };
    default:
      return state;
  }
};

export default AuthenticationReducer;
